import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useUser } from "../authentification/UserContext";
import { API_ENDPOINTS } from "../../../ApiService";
import apiService from "../../../ApiService";
import ClientMensurationDataDashboard from "../../components/clientDashboard/mensuration/ClientMensurationDataDashboard";
import Title from "../../components/title/Title";
import { MainContainer } from "../styles/sharedStyles";
import {
  calculateDifferences,
  formatTimestamp,
} from "../../components/clientDashboard/mensuration/dataProcessing/DataProcessing";
import Header from "../../components/Header";
import {
  Box,
  useTheme,
  useMediaQuery,
  Typography,
  Button,
} from "@mui/material";
import styled from "styled-components";
import MensurationGraph from "../../components/clientDashboard/mensuration/MensurationGraph";

const Section = styled.section`
  width: 100%;
  height: 100%;
  padding: 4rem 0rem;
`;

const MensurationsDashboard = () => {
  const { clientID } = useParams();
  const { user } = useUser();
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <MainContainer>
      <Title
        title="Tableau de bord des Mensurations"
        summary="Mensurations au cours de l'année"
      />
      <MensurationGraph />
    </MainContainer>
  );
};

export default MensurationsDashboard;
